import { AutoPilot as AutoPilotComponent } from "features/auto-pilot"

export const AutoPilot = () => (
  <AutoPilotComponent />
)